import React, { useEffect } from 'react';
import './Dashboard.css';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useUserActions } from '../../redux/actions/userActions';

interface LayoutProps {
    children: React.ReactNode;
}

const DashboardLayout: React.FC<LayoutProps> = ({ children }) => {
    const location = useLocation();
    useEffect(() => {
        const currentHash = location.hash.replace('#', '');
    }, [location]);

    const dispatch = useDispatch();
    const { getUserInfoData } = useUserActions();

    useEffect(() => {
        dispatch(getUserInfoData() as any);
    }, []);
    return (
        <>
            <Header />
            <div className="dashboard-container d-flex">
                {/* Sidebar */}
                <Sidebar />

                {/* Right Content (Empty for now) */}
                <div className="content-area flex-grow-1 pt-0 pr-0 pb-0 customer-wrapper">
                    {children}
                </div>
            </div>
        </>
    );
};

export default DashboardLayout;
